import LandingMain from "../view/site/landing/LandingMain";
import BaseComponent from "../../lib/components/BaseComponent";
import RouterElement from "../../lib/components/router/RouterElement";
import CM from "../model/system/CM";
import React from 'react';
import {ToastContainer} from "react-toastify";
import {ThemeOptions} from "@mui/material/styles";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import "react-toastify/dist/ReactToastify.css";
import DemoLinks from "./site/gem/DemoLinks";
import GemLinksAusschuss from "./site/gem/GemLinksAusschuss";
import GemLinksGlieder from "./site/gem/GemLinksGlieder";
import GemLinksGaeste from "./site/gem/GemLinksGaeste";
import GemLinksMain from "./site/gem/GemLinksMain";
import GemEmail from "./site/gem/gemeinde_email/GemEmail";

class App extends BaseComponent {

  constructor(props) {
    super(props);
    let theme = CM.get().getTheme() === CM.STD_DARK ? 'dark' : 'light';

    this.state = {
      muiTheme: createTheme(theme === 'dark' ? darkThemeOptions : lightThemeOptions), theme: theme
    };

    //when then constructor of this class is called, it means that the site was reloaded, so we need to clear the cache.
    CM.get().resetSessionValues();

    CM.get().addThemeChangeListener((theme) => {
      this.state.theme = theme === CM.STD_DARK ? 'dark' : 'light';
      this.state.muiTheme = createTheme(this.state.theme === 'dark' ? darkThemeOptions : lightThemeOptions);
      this.setState(this.state);
    });

  }

  render() {
    let mainDialog = CM.get().getMainDialog();

    return <React.Fragment>
      <ToastContainer
        position='bottom-left'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        rtl={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={this.state.theme}/>
      <ThemeProvider theme={this.state.muiTheme}>
        {mainDialog}
        <RouterElement route='^$|^landing.*$'><LandingMain p={this}/></RouterElement>
        <RouterElement route='^demolink.*$'><DemoLinks p={this}/></RouterElement>
        <RouterElement route='^gemeindelm.*$'><GemLinksMain p={this}/></RouterElement>
        <RouterElement route='^gemausschussWgodPgktnAlf9S3kgjQ1lgjdsGfk6.*$'><GemLinksAusschuss p={this}/></RouterElement>
        <RouterElement route='^gemgliederWgodPgkZnAlf0S3kgjQ1lgjdsGfk6.*$'><GemLinksGlieder p={this}/></RouterElement>
        <RouterElement route='^gemgaesteSgodPgktnAlf9S3kgjQ3lgjdsGfk6.*$'><GemLinksGaeste p={this}/></RouterElement>
        <RouterElement route='^gemeindele.*$'><GemEmail p={this}/></RouterElement>

      </ThemeProvider>
    </React.Fragment>;
  }
}

const cnBorderRadius18 = {
  borderTopLeftRadius: '0',
  borderTopRightRadius: '18px',
  borderBottomLeftRadius: '18px',
  borderBottomRightRadius: '18px'
};
const cnBorderRadius10 = {
  borderTopLeftRadius: '0',
  borderTopRightRadius: '10px',
  borderBottomLeftRadius: '10px',
  borderBottomRightRadius: '10px'
};
const cnBoxShadowDark = {
  boxShadow: '0px 4px 10px rgba(79, 143, 191, 1)'
};
const cnBoxShadowLight = {
  boxShadow: '0px 4px 10px rgba(176, 112, 64, 1)'
};

const lightThemeOptions: ThemeOptions = {
  palette: {
    mode: 'light', primary: {
      main: '#4f8fbf', contrastText: 'white',
    }, secondary: {
      main: '#189c93',
    }, background: {
      paper: '#fff', default: '#f2f2f2',
    }, error: {
      main: '#e06161',
    }, warning: {
      main: '#e09761',
    },
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: '#fefefe',
        },
        columnHeader: {
          backgroundColor: '#4f8fbf',
          color: 'white'
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          ...cnBorderRadius18,
          ...cnBoxShadowLight
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#000',
          ...cnBorderRadius10,
          "&:hover": {
            color: 'var(--color-landing-gray03)',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#fff",
          backgroundImage: 'none !important',
          ...cnBorderRadius18,
          ...cnBoxShadowLight
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          ...cnBorderRadius18
        },
      },
    },
  },
};

const darkThemeOptions: ThemeOptions = {
  palette: {
    mode: 'dark', primary: {
      main: '#4f8fbf'
    }, secondary: {
      main: '#27ccbc', dark: '#35a299', contrastText: '#fff', light: '#69e8dc',
    }, background: {
      paper: '#313131', default: '#313131',
    }, error: {
      main: '#e06161',
    }, warning: {
      main: '#e09761',
    },
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: '#2f2f2f',
        },
        columnHeader: {
          backgroundColor: '#4f8fbf',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          ...cnBorderRadius18,
          ...cnBoxShadowDark
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#fff',
          ...cnBorderRadius10,
          "&:hover": {
            color: 'var(--color-landing-gray03)',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#313131",
          backgroundImage: 'none',
          ...cnBorderRadius18,
          ...cnBoxShadowDark
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          ...cnBorderRadius18
        },
      },
    },
  },
}

export default App;
